import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import NewExceptionGrantModal from './NewExceptionGrantModal'
import NewExceptionExtendModal from './NewExceptionExtendModal'
import { useStateValue } from '../state'
import { NewExceptionBar } from './NewExceptionBar'
import { ProgressBar } from './ProgressBar'
import PropTypes from 'prop-types'

export const NewException = props => {
  const [newExceptionGrantModalOpen, toggleGrantModal] = useState(false)
  const [newExceptionExtendModalOpen, toggleExtendModal] = useState(false)
  const [currentState] = useStateValue()

  return (
    <div>
      <ProgressBar createException selectAssignments={false} review={false} />
      <div className="d-flex justify-content-center">
        {currentState.exceptionType !== '' ? (
          <NewExceptionBar displayRemoveButton />
        ) : (
          <div className="d-flex w-50 justify-content-around">
            <button
              className="btn btn-myed btn-default btn-default-myed text-black"
              style={{ fontSize: '13pt', width: '150px' }}
              onClick={() => toggleExtendModal(!newExceptionExtendModalOpen)}
            >
              <div
                style={{
                  fontSize: '20pt',
                  padding: '15px 15px 15px 0px',
                  margin: 'auto',
                }}
              >
                <span
                  style={{ fontSize: '11pt' }}
                  className="fas fa-plus fa-fw"
                />
                <span
                  style={{ fontSize: '20pt' }}
                  className="fas fa-calendar fa-fw"
                />
              </div>
              Extend Due <br /> Dates
            </button>
            <button
              className="btn btn-myed btn-default btn-default-myed text-black"
              style={{ fontSize: '13pt', width: '150px' }}
              onClick={() => toggleGrantModal(!newExceptionGrantModalOpen)}
            >
              <div style={{ fontSize: '20pt', padding: '15px 0px 15px 0px' }}>
                <span className="fas fa-hourglass fa-fw" />
              </div>
              Grant Extra <br /> Time
            </button>
          </div>
        )}
      </div>
      {currentState.isExceptionSet ? (
        <Link
          className="btn btn-myed btn-primary btn-primary-myed pull-right"
          to={`/instructor/ada_exceptions/${props.match.params.coursenum}/${props.match.params.studentid}/select_assignments`}
        >
          Next
        </Link>
      ) : (
        <button className="btn btn-myed btn-primary btn-primary-myed pull-right" disabled>
          Next
        </button>
      )}
      <Link
        className="btn btn-myed btn-default btn-default-myed pull-right mt-2"
        to={`/instructor/ada_exceptions/${props.match.params.coursenum}/${props.match.params.studentid}/`}
      >
        Back
      </Link>
      <NewExceptionGrantModal
        show={newExceptionGrantModalOpen}
        toggle={toggleGrantModal}
      />
      <NewExceptionExtendModal
        show={newExceptionExtendModalOpen}
        toggle={toggleExtendModal}
      />
    </div>
  )
}

NewException.propTypes = {
  match: PropTypes.object.isRequired,
}
